module.exports = __webpack_public_path__ + "static/media/P2.6cd95096.png";